import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-lg);

  .cont {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h2 {
      margin-right: 6px;
      margin-bottom: 0px;
      font-size: var(--font-size-lg);
      font-weight: 600;
      color: #1D2939;
    }
  }
`;
